import { render, staticRenderFns } from "./LawAssistance.vue?vue&type=template&id=10c978c7&scoped=true&"
import script from "./LawAssistance.vue?vue&type=script&lang=js&"
export * from "./LawAssistance.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/apply.css?vue&type=style&index=0&id=10c978c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c978c7",
  null
  
)

export default component.exports